export default "__VITE_ASSET__BN5v1upJ__"